import React, { Component } from 'react';
import Button from 'atoms/button';
import PropTypes from 'prop-types';
import Title from 'atoms/title';


export default class StickyBar extends Component {
  constructor(props) {
    super(props);
    this.stickyMobile = React.createRef();
  }

  render() {
    const {
      area, arrival, breadcrumb, categoryLiteral, city, clickoutSubsections, handleSaveClick,
      instantBook, isCookieBannerShowing, isSaved, leaving, mainPartner, numberFormat, t, title, titlePreposition,
    } = this.props;
    if (global.isPhone) {
      let cookieHeight = 0;
      if (isCookieBannerShowing) cookieHeight = document.getElementsByClassName('cookie-banner')[0].offsetHeight;
      const element = this.stickyMobile;
      if (element.current) element.current.style.bottom = `${cookieHeight}px`;
    }
    const listener = () => {
      const element = document.getElementById('sticky-desktop');
      const top = 616;
      if (!element) return;
      if (top < window.pageYOffset) element.classList.add("visible");
      else element.classList.remove("visible");
    };

    if (typeof window !== 'undefined' && "classList" in document.documentElement) {
      window.addEventListener('scroll', listener, false);
    }

    return (
      <div className="establishment-page__sticky">
        <div ref={ this.stickyMobile } className="establishment-page__sticky-mobile">
          <div className="establishment-page__sticky-mobile__container">
            <div className="establishment-page__sticky-mobile__container__left">
              { mainPartner.pricePerNight
                && (
                  <div>
                    <div className="establishment-page__sticky-mobile__container__left__price">
                      { t("{price}£", { price: numberFormat(mainPartner.pricePerNight) }) }
                    </div>
                    <span className="establishment-page__sticky-mobile__container__left__night">
                      { t("/night") }
                    </span>
                  </div>
                )
              }
              <div>
                { instantBook && <span className="establishment-page__sticky-mobile__container__left__icon hundredicons-bolt-filled" /> }
                <span className="establishment-page__sticky-mobile__container__left__partner-name">
                  { mainPartner.visibleName }
                </span>
              </div>
            </div>
            <div className="establishment-page__sticky-mobile__container__right">
              <Button
                className="establishment-page__sticky-mobile__container__right__button"
                handleOnClick={ mainPartner.handleClickout(clickoutSubsections.ESTABLISHMENT_CTA_STICKY) }
              >
                { t("View offer") }
              </Button>
            </div>
          </div>
        </div>
        <div className="establishment-page__sticky-desktop" id="sticky-desktop">
          <div className="establishment-page__sticky-desktop__container">
            <div className="establishment-page__sticky-desktop__container__left">
              <span
                className="establishment-page__sticky-desktop__container__left__partner-name"
                onClick={ mainPartner.handleClickout(clickoutSubsections.ESTABLISHMENT_LINK_STICKY) }
              >
                <span className="establishment-page__sticky-desktop__container__left__partner-name__text">
                  <Title
                    area={ area }
                    categoryLiteral={ categoryLiteral }
                    city={ city }
                    t={ t }
                    text={ title }
                    titlePreposition={ titlePreposition }
                  />
                  { (arrival && leaving)
                    && t("From {dateArrival} to {dateLeaving}.",
                      { dateArrival: arrival, dateLeaving: leaving })
                  }
                </span>
              </span>
            </div>
            <div className="establishment-page__sticky-desktop__container__right">
              <Button
                className="establishment-page__sticky-desktop__container__right__button"
                handleOnClick={ mainPartner.handleClickout(clickoutSubsections.ESTABLISHMENT_CTA_STICKY) }
              >
                { instantBook
                  && <span className="establishment-page__sticky-desktop__container__right__icon hundredicons-bolt-filled" />
                }
                { mainPartner.pricePerNight
                  && (
                    <span className="establishment-page__sticky-desktop__container__right__price">
                      { t("{price}£", { price: numberFormat(mainPartner.pricePerNight) }) }
                    </span>
                  )
                }
                { t("View offer") }
              </Button>
              { !breadcrumb
              && (
                <div className="establishment-page__sticky-desktop__container__right__icons">
                  <div
                    className="establishment-page__sticky-desktop__container__right__icons__favourite"
                    onClick={ () => handleSaveClick('sticky') }
                  >
                    <span className={ `establishment-page__sticky-desktop__container__right__icons__favourite__icon ${isSaved ? 'hundredicons-hr-icon-favorito-filled' : 'hundredicons-hr-icon-favorito'}` } />
                  </div>
                </div>
              )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StickyBar.defaultProps = {
  area: 0,
  breadcrumb: null,
  categoryLiteral: '',
  city: '',
  clickoutSubsections: {},
  instantBook: false,
  isCookieBannerShowing: false,
  isSaved: false,
  numberFormat: n => n,
  title: '',
  titlePreposition: '',
};

StickyBar.propTypes = {
  area: PropTypes.number,
  arrival: PropTypes.string.isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  })),
  categoryLiteral: PropTypes.string,
  city: PropTypes.string,
  clickoutSubsections: PropTypes.shape(),
  handleSaveClick: PropTypes.func.isRequired,
  instantBook: PropTypes.bool,
  isCookieBannerShowing: PropTypes.bool,
  isSaved: PropTypes.bool,
  leaving: PropTypes.string.isRequired,
  mainPartner: PropTypes.shape({
    clickoutLink: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    favicon: PropTypes.string,
    handleClickout: PropTypes.func,
    id: PropTypes.number,
    pricePerNight: PropTypes.number,
    priceTotal: PropTypes.number,
    visibleName: PropTypes.string,
  }).isRequired,
  numberFormat: PropTypes.func,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
  titlePreposition: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
